import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { indiceDesempeno } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const IndiceComponente = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (municipioId) {
            fetchData();
        }
    }, [municipioId]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await indiceDesempeno(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    setData(fetchedData);
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // Definición de las columnas con los títulos correspondientes
    const columns = [
        {
            title: 'Indicadores',
            dataIndex: 'indicador',
            key: 'indicador',
        },
        {
            title: 'Gestión',
            dataIndex: 'gestion',
            key: 'gestion',
        },
        {
            title: 'Resultados',
            dataIndex: 'resultados',
            key: 'resultados',
        },
        {
            title: 'Índice final de desempeño del Municipio',
            dataIndex: 'indice',
            key: 'indice',
        },
    ];

    // Función para transformar los datos del JSON a las filas de la tabla
    const transformData = (item) => [
        { key: 'gestion_puntaje', indicador: 'Puntaje de Gestión', gestion: item.gestion_puntaje, resultados: item.resultados_puntaje, indice: item.indice_puntaje },
        { key: 'gestion_posicion', indicador: 'Posición de Gestión', gestion: item.gestion_posicion, resultados: item.resultados_posicion, indice: item.indice_posicion },
        { key: 'gestion_puntaje_romedio', indicador: 'Puntaje Promedio de Gestión', gestion: item.gestion_puntaje_romedio, resultados: item.resultados_puntaje_romedio, indice: item.indice_puntaje_romedio },
        { key: 'gestion_posicion_nacional', indicador: 'Posición Nacional de Gestión', gestion: item.gestion_posicion_nacional, resultados: item.resultados_posicion_nacional, indice: item.indice_posicion_nacional },
    ];

    // Los datos transformados a formato adecuado para la tabla
    const tableData = data.length ? transformData(data[0]) : [];

    return (
        <div className="page-content">
            <h1>COMPONENTE DE INVERSIÓN PÚBLICA</h1>
            <div>
                <h3> Reportes Sistema General de Participaciones - SGP</h3>
                {loading ? (
                    <Spin size="large" />
                ) : (
                    <Table
                        columns={columns}
                        dataSource={tableData}
                        rowKey="key"
                        pagination={false}
                    />
                )}
            </div>
        </div>
    );
};

export default IndiceComponente;
